export const deviceShipmentsDashboardTypes = {
    UPDATE_REQUEST: "DEVICE_DASHBOARD_UPDATE_REQUEST",
    FETCH_RSSI_HISTORY_REQUEST: "DEVICE_SHIPMENT_FETCH_RSSI_HISTORY_REQUEST",
    FETCH_RSSI_HISTORY_SUCCESS: "DEVICE_SHIPMENT_FETCH_RSSI_HISTORY_SUCCESS",
    FETCH_RSSI_HISTORY_FAILURE: "DEVICE_SHIPMENT_FETCH_RSSI_HISTORY_FAILURE",
    FETCH_HUMIDITY_REQUEST: "DEVICE_DASHBOARD_FETCH_HUMIDITY_REQUEST",
    FETCH_HUMIDITY_SUCCESS: "DEVICE_DASHBOARD_FETCH_HUMIDITY_SUCCESS",
    FETCH_HUMIDITY_FAILURE: "DEVICE_DASHBOARD_FETCH_HUMIDITY_FAILURE",
    FETCH_BATTERY_HISTORY_REQUEST: "DEVICE_SHIPMENT_FETCH_BATTERY_HISTORY_REQUEST",
    FETCH_BATTERY_HISTORY_SUCCESS: "DEVICE_SHIPMENT_FETCH_BATTERY_HISTORY_SUCCESS",
    FETCH_BATTERY_HISTORY_FAILURE: "DEVICE_SHIPMENT_FETCH_BATTERY_HISTORY_FAILURE",
    FETCH_PRESSURE_REQUEST: "DEVICE_DASHBOARD_FETCH_PRESSURE_REQUEST",
    FETCH_PRESSURE_SUCCESS: "DEVICE_DASHBOARD_FETCH_PRESSURE_SUCCESS",
    FETCH_PRESSURE_FAILURE: "DEVICE_DASHBOARD_FETCH_PRESSURE_FAILURE",
    FETCH_SIGNAL_HISTORY_REQUEST: "DEVICE_SHIPMENT_FETCH_SIGNAL_HISTORY_REQUEST",
    FETCH_SIGNAL_HISTORY_SUCCESS: "DEVICE_SHIPMENT_FETCH_SIGNAL_HISTORY_SUCCESS",
    FETCH_SIGNAL_HISTORY_FAILURE: "DEVICE_SHIPMENT_FETCH_SIGNAL_HISTORY_FAILURE",
    FETCH_TEMPERATURE_REQUEST: "DEVICE_DASHBOARD_FETCH_TEMPERATURE_REQUEST",
    FETCH_TEMPERATURE_SUCCESS: "DEVICE_DASHBOARD_FETCH_TEMPERATURE_SUCCESS",
    FETCH_TEMPERATURE_FAILURE: "DEVICE_DASHBOARD_FETCH_TEMPERATURE_FAILURE",
    FETCH_LIGHT_REQUEST: "DEVICE_DASHBOARD_FETCH_LIGHT_REQUEST",
    FETCH_LIGHT_SUCCESS: "DEVICE_DASHBOARD_FETCH_LIGHT_SUCCESS",
    FETCH_LIGHT_FAILURE: "DEVICE_DASHBOARD_FETCH_LIGHT_FAILURE",
    FETCH_TILT_REQUEST: "DEVICE_DASHBOARD_FETCH_TILT_REQUEST",
    FETCH_TILT_SUCCESS: "DEVICE_DASHBOARD_FETCH_TILT_SUCCESS",
    FETCH_TILT_FAILURE: "DEVICE_DASHBOARD_FETCH_TILT_FAILURE",
    FETCH_SHOCK_ALARM_HISTORY_REQUEST: "DEVICE_SHIPMENT_FETCH_SHOCK_ALARM_HISTORY_REQUEST",
    FETCH_SHOCK_ALARM_HISTORY_SUCCESS: "DEVICE_SHIPMENT_FETCH_SHOCK_ALARM_HISTORY_SUCCESS",
    FETCH_SHOCK_ALARM_HISTORY_FAILURE: "DEVICE_SHIPMENT_FETCH_SHOCK_ALARM_HISTORY_FAILURE",
};

export const updateRequest = (req) => ({
    type: deviceShipmentsDashboardTypes.UPDATE_REQUEST,
    payload: req
});

export const fetchRSSIHistoryRequest = (req) => ({
    type: deviceShipmentsDashboardTypes.FETCH_RSSI_HISTORY_REQUEST,
    payload: req
});

export const fetchRSSIHistorySuccess = (resp) => ({
    type: deviceShipmentsDashboardTypes.FETCH_RSSI_HISTORY_SUCCESS,
    payload: resp
});

export const fetchRSSIHistoryFailure = (error) => ({
    type: deviceShipmentsDashboardTypes.FETCH_RSSI_HISTORY_FAILURE,
    payload: error
});

export const fetchHumidityRequest = (req) => ({
    type: deviceShipmentsDashboardTypes.FETCH_HUMIDITY_REQUEST,
    payload: req
});


export const fetchHumiditySuccess = (resp) => ({
    type: deviceShipmentsDashboardTypes.FETCH_HUMIDITY_SUCCESS,
    payload: resp
});

export const fetchHumidityFailure = (error) => ({
    type: deviceShipmentsDashboardTypes.FETCH_HUMIDITY_FAILURE,
    payload: error
});

export const fetchLightRequest = (req) => ({
    type: deviceShipmentsDashboardTypes.FETCH_LIGHT_REQUEST,
    payload: req
});


export const fetchLightSuccess = (resp) => ({
    type: deviceShipmentsDashboardTypes.FETCH_LIGHT_SUCCESS,
    payload: resp
});

export const fetchLightFailure = (error) => ({
    type: deviceShipmentsDashboardTypes.FETCH_LIGHT_FAILURE,
    payload: error
});

export const fetchTiltRequest = (req) => ({
    type: deviceShipmentsDashboardTypes.FETCH_TILT_REQUEST,
    payload: req
});


export const fetchTiltSuccess = (resp) => ({
    type: deviceShipmentsDashboardTypes.FETCH_TILT_SUCCESS,
    payload: resp
});

export const fetchTiltFailure = (error) => ({
    type: deviceShipmentsDashboardTypes.FETCH_TILT_FAILURE,
    payload: error
});

export const fetchBatteryHistoryRequest = (req) => ({
    type: deviceShipmentsDashboardTypes.FETCH_BATTERY_HISTORY_REQUEST,
    payload: req
});
export const fetchTemperatureRequest = (req) => ({
    type: deviceShipmentsDashboardTypes.FETCH_TEMPERATURE_REQUEST,
    payload: req
});
export const fetchTemperatureSuccess = (resp) => ({
    type: deviceShipmentsDashboardTypes.FETCH_TEMPERATURE_SUCCESS,
    payload: resp
});
export const fetchTemperatureFailure = (error) => ({
    type: deviceShipmentsDashboardTypes.FETCH_TEMPERATURE_FAILURE,
    payload: error
});

export const fetchBatteryHistorySuccess = (resp) => ({
    type: deviceShipmentsDashboardTypes.FETCH_BATTERY_HISTORY_SUCCESS,
    payload: resp
});

export const fetchBatteryHistoryFailure = (error) => ({
    type: deviceShipmentsDashboardTypes.FETCH_BATTERY_HISTORY_FAILURE,
    payload: error
});

export const fetchPressureRequest = (req) => ({
    type: deviceShipmentsDashboardTypes.FETCH_PRESSURE_REQUEST,
    payload: req
});

export const fetchPressureSuccess = (resp) => ({
    type: deviceShipmentsDashboardTypes.FETCH_PRESSURE_SUCCESS,
    payload: resp
});

export const fetchPressureFailure = (error) => ({
    type: deviceShipmentsDashboardTypes.FETCH_PRESSURE_FAILURE,
    payload: error
});
export const fetchSignalHistoryRequest = (req) => ({
    type: deviceShipmentsDashboardTypes.FETCH_SIGNAL_HISTORY_REQUEST,
    payload: req
});

export const fetchSignalHistorySuccess = (resp) => ({
    type: deviceShipmentsDashboardTypes.FETCH_SIGNAL_HISTORY_SUCCESS,
    payload: resp
});

export const fetchSignalHistoryFailure = (error) => ({
    type: deviceShipmentsDashboardTypes.FETCH_SIGNAL_HISTORY_FAILURE,
    payload: error
});

export const fetchShockAlarmHistoryRequest = (req) => ({
    type: deviceShipmentsDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_REQUEST,
    payload: req
});

export const fetchShockAlarmHistorySuccess = (resp) => ({
    type: deviceShipmentsDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_SUCCESS,
    payload: resp
});

export const fetchShockAlarmHistoryFailure = (error) => ({
    type: deviceShipmentsDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_FAILURE,
    payload: error
});